import { useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { CheckIcon, CopyIcon } from 'lucide-react';

interface CopyButtonProps {
  text: string;
  label?: string;
  className?: string;
  iconOnly?: boolean;
}

export function CopyButton({ text, label = 'Copy', className = '', iconOnly = false }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Copy failed. Try using HTTPS.');
    }
  }, [text]);

  if (iconOnly) {
    return (
      <button
        onClick={handleCopy}
        className={`btn btn-sm btn-ghost ${copied ? 'text-success' : ''} ${className}`}
        title={copied ? 'Copied!' : label}
        aria-label={copied ? 'Copied!' : label}
      >
        {copied ? <CheckIcon className="size-4" /> : <CopyIcon className="size-4" />}
      </button>
    );
  }

  return (
    <button
      onClick={handleCopy}
      className={`btn btn-sm ${
        copied
          ? 'btn-success'
          : 'btn-outline'
      } ${className}`}
    >
      {copied ? 'Copied!' : label}
    </button>
  );
}
